<template>
  <div class="main supervision-main">
    <el-card shadow="never" class="statistics-card">
      <el-radio-group v-model="tabs" @change="handleChangeType">
        <el-radio-button label="today">今日</el-radio-button>
        <el-radio-button label="yesterday">昨日</el-radio-button>
        <el-radio-button label="week">本周</el-radio-button>
        <el-radio-button label="month">本月</el-radio-button>
        <el-radio-button label="year">今年</el-radio-button>
      </el-radio-group>
      <el-row :gutter="0" style="margin-top: 16px">
        <el-col :span="6">
          <div>处方药品总数</div>
          <div class="body">
            <span class="num">{{ statics.totalPrescriptionDrugNum || 0 }}</span>
            <span class="unit">条</span>
          </div>
        </el-col>
        <el-col :span="6" v-if="prescriptionShow">
          <div>电子处方药品</div>
          <div class="body">
            <span class="num">{{ statics.electronicPrescriptionDrugNum || 0 }}</span>
            <span class="unit">条</span>
          </div>
        </el-col>
        <el-col :span="6" v-if="prescriptionShow">
          <div>线下处方药品</div>
          <div class="body">
            <span class="num">{{ statics.offlinePrescriptionDrugNum || 0 }}</span>
            <span class="unit">条</span>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card>
      <el-tabs v-model="activeName" v-if="prescriptionShow">
        <el-tab-pane label="电子处方" name="online">
          <online></online>
        </el-tab-pane>
        <el-tab-pane label="线下处方" name="offline">
          <offline></offline>
        </el-tab-pane>
      </el-tabs>
      <online v-else></online>
    </el-card>
  </div>
</template>

<script>
import Online from './components/prescriptionSupervision/online';
import Offline from './components/prescriptionSupervision/offline';
import { type2Datetime } from '@/util';
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    Online,
    Offline
  },
  data() {
    return {
      tabs: 'today',
      statics: {},
      activeName: 'online'
    };
  },
  computed: {
    ...mapGetters(['storeList']),
    ...mapState('permission', ['supervisionConfig']),
    prescriptionShow() {
      return !this.supervisionConfig?.prescriptionConfig?.hiddenOfflinePrescription;
    },
    pickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },
          {
            text: '昨日',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }
        ]
      };
    },
    storeId() {
      // 多店业务上暂时不考虑
      const { storeList } = this;
      return Array.isArray(storeList) ? storeList?.[0].id : storeList?.id;
    }
  },
  mounted() {
    this.getTotal();
  },
  methods: {
    handleChangeType(type) {
      this.getTotal(type);
    },
    getTotal(type = 'today') {
      const params = type2Datetime(type);
      const { storeId } = this;
      Fetch.getPrescriptionSummary({ ...params, storeId }).then(res => {
        this.statics = res || {};
      });
    }
  }
};
</script>
<style lang="scss" scoped></style>
